import { render, staticRenderFns } from "./gallerymodale.vue?vue&type=template&id=4d6cfd9c&scoped=true"
import script from "./gallerymodale.vue?vue&type=script&lang=js"
export * from "./gallerymodale.vue?vue&type=script&lang=js"
import style0 from "./gallerymodale.vue?vue&type=style&index=0&id=4d6cfd9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6cfd9c",
  null
  
)

export default component.exports